import React, { Fragment, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import { List, ListItem, ListItemIcon, ListItemText, Tooltip } from '@material-ui/core'
import DashboardIcon from '@material-ui/icons/Dashboard'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday'
import ExitToApp from '@material-ui/icons/ExitToApp'
import Collapse from '@material-ui/core/Collapse'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'

// EVENTS ICONS
import AssessmentIcon from '@material-ui/icons/Assessment'
import ViewQuiltIcon from '@material-ui/icons/ViewQuilt'

// ORDERS ICONS
import LocalPharmacyIcon from '@material-ui/icons/LocalPharmacy'
import HomeWorkIcon from '@material-ui/icons/HomeWork'
// import TableChart from '@material-ui/icons/TableChart'
import TrendingDownIcon from '@material-ui/icons/TrendingDown'

// BASKET ICONS
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket'

// PRODUCT ICONS
import EnhancedEncryptionIcon from '@material-ui/icons/EnhancedEncryption'
import { AuthContext } from '../../context/AuthContext'
import { LayoutContext } from '../../context/LayoutContext'
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      maxWidth: 420,
      backgroundColor: theme.palette.background.paper
    },
    nested: {
      paddingLeft: theme.spacing(4)
    },
    logoutBtn: {
      marginLeft: 30
    }
  })
)

export const MainListItems = (props: any): JSX.Element => {
  const history = useHistory()
  const { layout } = useContext(LayoutContext)
  const { drawerEffect } = props

  const handleClick = (path: string): void => {
    history.push(path)
    drawerEffect()
  }

  return (
    <Fragment>
      <Tooltip title="Monitoramento diário" placement="left" disableHoverListener={layout.isMenuOpen}>
        <ListItem button onClick={() => handleClick('/monitoramento-diario/detalhe-principal')}>
          <ListItemIcon><CalendarTodayIcon /></ListItemIcon>
          <ListItemText primary="Monitoramento diário" />
        </ListItem>
      </Tooltip>
    </Fragment>
  )
}

export const SecondaryList = (props: any): JSX.Element => {
  const classes = useStyles()
  const history = useHistory()
  const { layout } = useContext(LayoutContext)
  const { drawerEffect } = props

  const [open, setOpen] = React.useState(true)
  const handleClick = (path: string): void => {
    history.push(path)
    drawerEffect()
  }

  const handleClickExpand = () => {
    setOpen(!open)
  }

  return (
    <Fragment>
      <Tooltip title="Eventos de Integração" placement="left" disableHoverListener={layout.isMenuOpen}>
        <ListItem button onClick={handleClickExpand}>
          <ListItemIcon><AssessmentIcon /></ListItemIcon>
          <ListItemText primary="Eventos de Integração" />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
      </Tooltip>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Tooltip title="Overview" placement="left" disableHoverListener={layout.isMenuOpen}>
            <ListItem button className={classes.nested} onClick={() => handleClick('/analise-de-eventos/overview')}>
              <ListItemIcon><ViewQuiltIcon /></ListItemIcon>
              <ListItemText primary="Overview" />
            </ListItem>
          </Tooltip>
        </List>
      </Collapse>
    </Fragment>
  )
}

export const BrandList = (props: any): JSX.Element => {
  // const classes = useStyles()
  const history = useHistory()
  const { layout } = useContext(LayoutContext)
  const { drawerEffect } = props

  // const [open, setOpen] = React.useState(true)
  const handleClick = (path: string): void => {
    history.push(path)
    drawerEffect()
  }

  // const handleClickExpand = () => {
  //   setOpen(!open)
  // }

  return (
    <Fragment>
      <Tooltip title="Indústrias" placement="left" disableHoverListener={layout.isMenuOpen}>
        <ListItem button onClick={() => handleClick('/industrias')}>
          <ListItemIcon><HomeWorkIcon /></ListItemIcon>
          <ListItemText primary="Indústrias" />
        </ListItem>
      </Tooltip>
      {/* <Tooltip title="Eventos de Integração" placement="left" disableHoverListener={layout.isMenuOpen}>
        <ListItem button onClick={handleClickExpand}>
          <ListItemIcon><AssessmentIcon /></ListItemIcon>
          <ListItemText primary="Eventos de Integração" />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
      </Tooltip> */}

      {/* <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Tooltip title="Overview" placement="left" disableHoverListener={layout.isMenuOpen}>
            <ListItem button className={classes.nested} onClick={() => handleClick('/analise-de-eventos/overview')}>
              <ListItemIcon><ViewQuiltIcon /></ListItemIcon>
              <ListItemText primary="Overview" />
            </ListItem>
          </Tooltip>
        </List>
      </Collapse> */}
    </Fragment>
  )
}

export const ProductList = (props: any): JSX.Element => {
  // const classes = useStyles()
  const history = useHistory()
  const { layout } = useContext(LayoutContext)
  const { drawerEffect } = props

  const handleClick = (path: string): void => {
    history.push(path)
    drawerEffect()
  }

  return (
    <Fragment>
      <Tooltip title="Produtos" placement="left" disableHoverListener={layout.isMenuOpen}>
        <ListItem button onClick={() => handleClick('/produtos')}>
          <ListItemIcon><EnhancedEncryptionIcon /></ListItemIcon>
          <ListItemText primary="Produtos" />
        </ListItem>
      </Tooltip>
    </Fragment>
  )
}

export const OrdersList = (props: any): JSX.Element => {
  const classes = useStyles()
  const history = useHistory()
  const { layout } = useContext(LayoutContext)
  const { drawerEffect } = props

  const [open, setOpen] = React.useState(true)
  const handleClick = (path: string): void => {
    history.push(path)
    drawerEffect()
  }

  const handleClickExpand = () => {
    setOpen(!open)
  }

  return (
    <Fragment>
      <Tooltip title="Pedidos" placement="left" disableHoverListener={layout.isMenuOpen}>
        <ListItem button onClick={handleClickExpand}>
          <ListItemIcon><LocalPharmacyIcon /></ListItemIcon>
          <ListItemText primary="Pedidos" />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
      </Tooltip>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Tooltip title="Overview" placement="left" disableHoverListener={layout.isMenuOpen}>
            <ListItem button className={classes.nested} onClick={() => handleClick('/pedidos/overview')}>
              <ListItemIcon><ViewQuiltIcon /></ListItemIcon>
              <ListItemText primary="Overview" />
            </ListItem>
          </Tooltip>
        </List>
      </Collapse>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Tooltip title="Farmácias" placement="left" disableHoverListener={layout.isMenuOpen}>
            <ListItem button className={classes.nested} onClick={() => handleClick('/pedidos/farmacies')}>
              <ListItemIcon><DashboardIcon /></ListItemIcon>
              <ListItemText primary="Farmácias" />
            </ListItem>
          </Tooltip>
          <Tooltip title="Detalhes" placement="left" disableHoverListener={layout.isMenuOpen}>
            <ListItem button className={classes.nested} onClick={() => handleClick('/pedidos/detailed-pharmacy')}>
              <ListItemIcon><HomeWorkIcon /></ListItemIcon>
              <ListItemText primary="Detalhamento de farmácias" />
            </ListItem>
          </Tooltip>
          {/* <Tooltip title="Lista de pedidos" placement="left" disableHoverListener={layout.isMenuOpen}>
            <ListItem button className={classes.nested} onClick={() => handleClick('/pedidos/orders-table')}>
              <ListItemIcon><TableChart /></ListItemIcon>
              <ListItemText primary="Lista de pedidos" />
            </ListItem>
          </Tooltip> */}
          <Tooltip title="Perdas" placement="left" disableHoverListener={layout.isMenuOpen}>
            <ListItem button className={classes.nested} onClick={() => handleClick('/pedidos/perdas')}>
              <ListItemIcon><TrendingDownIcon /></ListItemIcon>
              <ListItemText primary="Perdas" />
            </ListItem>
          </Tooltip>
        </List>
      </Collapse>
    </Fragment>
  )
}

export const CartChange = (props: any): JSX.Element => {
  const classes = useStyles()
  const history = useHistory()
  const { layout } = useContext(LayoutContext)
  const { drawerEffect } = props

  const [open, setOpen] = React.useState(true)
  const handleClick = (path: string): void => {
    history.push(path)
    drawerEffect()
  }

  const handleClickExpand = () => {
    setOpen(!open)
  }

  return (
    <Fragment>
      <Tooltip title="Mudança de cesta" placement="left" disableHoverListener={layout.isMenuOpen}>
        <ListItem button onClick={handleClickExpand}>
          <ListItemIcon><ShoppingBasketIcon /></ListItemIcon>
          <ListItemText primary="Mudança de cesta" />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
      </Tooltip>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Tooltip title="Overview" placement="left" disableHoverListener={layout.isMenuOpen}>
            <ListItem button className={classes.nested} onClick={() => handleClick('/mudanca-de-cesta/overview')}>
              <ListItemIcon><ViewQuiltIcon /></ListItemIcon>
              <ListItemText primary="Overview" />
            </ListItem>
          </Tooltip>
        </List>
      </Collapse>
    </Fragment>
  )
}

export const LogoutItem = (): JSX.Element => {
  const { setAuth } = useContext(AuthContext)
  const classes = useStyles()

  const handleClickLogout = (): void => {
    setAuth(
      {
        accessToken: '',
        idToken: '',
        email: '',
        name: ''
      }
    )
    sessionStorage.clear()
    localStorage.clear()
  }

  return (
    <Fragment>
      {/* <ListSubheader inset>Saved reports</ListSubheader> */}
      <ListItem button onClick={() => { handleClickLogout() }} className={classes.logoutBtn}>
        <ListItemIcon>
          <ExitToApp />
        </ListItemIcon>
        <ListItemText style={{ marginLeft: -20 }} primary="Sair" />
      </ListItem>
    </Fragment>
  )
}
